import {KazBlurImageComponent} from '../kaz-blur-image/kaz-blur-image.component';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import {Ad, PriceType} from "../../interfaces/ad";
import {ApiService} from "../../services/api.service";
import {getDummyPicture} from "../../utils/dummyImages";
import {setPreviousAd} from "../../utils/sessionStorage";
import { Router, RouterLink } from "@angular/router";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CurrencyPipe } from '@angular/common';
import { ImageSourcePipe } from '../../pipes/image-source.pipe';

@Component({
    selector: 'kaz-card-archive-ads',
    templateUrl: './kaz-card-archive-ads.component.html',
    styleUrls: ['./kaz-card-archive-ads.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazBlurImageComponent, RouterLink, FaIconComponent, CurrencyPipe, ImageSourcePipe]
})
export class KazCardArchiveAdsComponent {
  private _api = inject(ApiService);
  private _router = inject(Router);

  @Output() wasDeleted = new EventEmitter<void>();
  @Input() ad: Ad | null = null;
  showDelete: boolean = false;

  async ngOnInit() {
  }

  async reCreatAd(ad: Ad) {
    setPreviousAd(ad);
    this._router.navigate(['/entry/create']).then();
  }

  toggleDelete() {
    this.showDelete = !this.showDelete;
  }

  async deleteAd() {
    try {
      if (this.ad !== null) {
        await this._api.deleteAd(this.ad.id);
      }
      this.wasDeleted.emit();
    } catch (err) {

    }
  }
  protected readonly getDummyPicture = getDummyPicture;

  protected readonly PriceType = PriceType;
}
